import { render, staticRenderFns } from "./ArchiveInventoryNoteModal.vue?vue&type=template&id=28f8687d&"
import script from "./ArchiveInventoryNoteModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveInventoryNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveInventoryNoteModal.vue"
export default component.exports